<template>
  <div class="c-thumbnail" @click="handleClick">

    <div class="c-thumbnail__image o-ratio o-ratio--16:9">
      <LazyImage
        class='u-absolute'
        :lazy-src="project.thumbnailSrc"
        :lazy-srcset="project.thumbnailSrc"
      />
      <div class="c-thumbnail__overlay">
        <Play />
      </div>
    </div>

    <div class="my-small">
      <div class="c-thumbnail__client">{{ project.client }}</div>
      <div class="o-quote">{{ project.name }}</div>
    </div>

  </div>
</template>

<script>
import LazyImage from '@/components/LazyImage.vue';
import Play from '@/assets/svg/Play.vue';

export default {
  components: { LazyImage, Play },
  props: {
    project: Object,
    page: String,
  },
  methods: {
    handleClick() {
      const videoUrl = `${this.page}/${this.project.slug}`;
      this.$router.push(videoUrl);
    },
  },
};
</script>
